import './App.css';
import SamHorizontalTimeline from './SamHorizontalTimeline';

function App() {
  return (
    <div className="App">
      <SamHorizontalTimeline />
    </div>
  );
}

export default App;